import firebase from 'firebase'
const config = {
    apiKey: "AIzaSyC6-W7LrtZxKMSd7FyM5m8GG2-Afj6ulPM",
    authDomain: "covid-6c09c.firebaseapp.com",
    databaseURL: "https://covid-6c09c.firebaseio.com",
    projectId: "covid-6c09c",
    storageBucket: "covid-6c09c.appspot.com",
    messagingSenderId: "164377192082",
    appId: "1:164377192082:web:2521196060272c1068e84b"
};
export const firebaseApp = firebase.initializeApp(config);
